import { motion } from 'motion/react';

import { useGetParams } from 'hooks/useGetParams';
import { formatPhoneNumber } from 'helpers/titreHelper';

import styles from './Advt.module.css';

export const Advt = ({ initDelay = 1 }) => {
  const {
    phoneNumber,
    qrCode1,
    qrCode2,
    qrTitle1,
    qrTitle2,
    sizeQR = '14.7',
  } = useGetParams();

  const clrBorder = {
    whatsapp: '#a0ffa4',
    telegram: '#28A5E5',
  };

  const arrPhoneNumber = formatPhoneNumber(phoneNumber)?.split('');

  return (
    <div className={styles.advtWrapper}>
      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <div
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <motion.img
              initial={{ scale: 0 }}
              animate={{
                scale: 1,
                transition: { duration: 0.64, delay: 0.12 + initDelay },
              }}
              exit={{ scale: 0, transition: { duration: 0.64 } }}
              src={qrCode1}
              alt=""
            />
            <motion.div
              initial={{ scale: 0 }}
              animate={{
                scale: 1,
                transition: { duration: 0.64, delay: 0 + initDelay },
              }}
              className={styles.borderQr}
              exit={{ scale: 0, transition: { duration: 0.64, delay: 0.12 } }}
              style={{
                borderColor: clrBorder[qrTitle1],
              }}
            />
          </div>
        )}
        {qrCode2 && (
          <div
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <motion.img
              initial={{ scale: 0 }}
              animate={{
                scale: 1,
                transition: { duration: 0.64, delay: 0.36 + initDelay },
              }}
              exit={{ scale: 0, transition: { duration: 0.64 } }}
              src={qrCode2}
              alt=""
            />
            <motion.div
              initial={{ scale: 0 }}
              animate={{
                scale: 1,
                transition: { duration: 0.64, delay: 0.24 + initDelay },
              }}
              exit={{ scale: 0, transition: { duration: 0.64, delay: 0.12 } }}
              className={styles.borderQr}
              style={{
                borderColor: clrBorder[qrTitle2],
              }}
            />
          </div>
        )}
      </div>

      <div className={styles.phoneNumber}>
        {arrPhoneNumber.map((l, idx) => (
          <motion.div
            key={l + idx}
            initial={{ scale: 0, originY: '100%', originX: 'center' }}
            animate={{
              scale: 1,
              transition: { duration: 0.88, delay: 1 + initDelay },
            }}
            exit={{ scale: 0, transition: { duration: 0.64, delay: 0 } }}
            style={{ minWidth: l === ' ' && '2rem' }}
          >
            {l}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
